import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import styles from "./style.module.scss";
const RecievedCreditz = ({ setView, setValues }) => {
  const { creditzs = [], currentUser } = useSelector((state) => ({
    creditzs: state.profile.creditz,
    currentUser: state.profile.currentUser,
  }));

  const onSelect = (values) => {
    setValues({ post: values });
    setView();
  };

  return (
    <div className={styles.creditzContainer}>
      <div className={styles.header}>
        <div className={styles.sender}>Sender</div>
        <div className={styles.artwork}>Artwork</div>
        <div className={styles.type}>Type</div>
        <div className={styles.title}>Title</div>
        <div className={styles.role}>Role</div>
      </div>
      <div className={`${styles.content} ${styles.acceptedCreditz}`}>
        {creditzs
          .sort((a, b) => (a.timestamp > b.timestamp ? -1 : 1))
          .map((creditz, index) => {
            return (
              <div key={index}>
                <div className={styles.row}>
                  <div className={styles.sender}>@{currentUser.username}</div>
                  <div
                    className={styles.artwork}
                    onClick={() => onSelect(creditz)}
                  >
                    <img
                      src={creditz.albumImage || creditz.videoImage}
                      alt="musicImg"
                    />
                  </div>
                  <div className={styles.type}>
                    {creditz.trackName ? "Music" : "Video"}
                  </div>
                  <div className={styles.title}>
                    {creditz.trackName || creditz.videoTrackName}
                  </div>
                  <div className={styles.role}>
                    <div>{creditz.role}</div>
                  </div>
                </div>
                {index + 1 < creditz.length && <hr className={styles.hr} />}
              </div>
            );
          })}
      </div>
    </div>
  );
};

RecievedCreditz.propTypes = {
  setView: PropTypes.func,
  setValues: PropTypes.func,
};
export default RecievedCreditz;
